import React from 'react'

export default class Work extends React.Component {
  render() {
    return (
      <div
        id="workhere"
        className="clearfix scrl section translucent-bg-nichesoft nichesoft-watermark-img"
        data-animation-effect="fadeIn"
      >
        <div className="container-fluid style={{color: 'black'}}">
          <h1 className="title text-center" style={{ marginTop: '4.5%' }}>
            <span>Work Culture</span>
          </h1>
          <div className="row">
            <div className="col-md-12 col-lg-12">
              <p
                style={{
                  fontWeight: 'bold',
                }}
              >
                For Engineers, By Engineers
              </p>
              <p />
              <p />
              <ul>
                <li>
                  NicheSolv founder -{' '}
                  <a
                    href="http://in.linkedin.com/in/natrajgujran"
                    target="_blank"
                  >
                    Natraj
                  </a>{' '}
                  - has 20+ years' experience in the industry. Some NicheSolv
                  engineers were born the year he finished his Master&apos;s
                  degree, so he relatively is old. And he still codes (or thinks
                  he does).
                </li>
                <li>
                  <a
                    href="https://in.linkedin.com/in/surendracr/"
                    target="_blank"
                  >
                    Surendra
                  </a>
                  {' and '}
                  <a
                    href="https://www.linkedin.com/in/ragoth-sundararajan-9b606712/"
                    target="_blank"
                  >
                    Ragoth
                  </a>{' '}
                  are of similar vintage - but are hands-on.
                </li>
                <li>
                  Therefore, caring &amp; obsessing about good design/code is
                  part of the DNA here.
                </li>
                <li>
                  Engineering and engineers are held in high regard. You will
                  not hear silly HR phrases like &apos;code coolies&apos;. We
                  believe, being a good &apos;code coolie&apos; is a non-trivial
                  job, and we&apos;re proud of it. :){' '}
                </li>
                <li>
                  You also will not be hearing management jargon such as working
                  the paradigm shift, valuing prepositions, etc.
                </li>
              </ul>
              <p />
            </div>
          </div>
          <br />
          <div className="row">
            <div className="col-md-12 col-lg-12">
              <p
                style={{
                  fontWeight: 'bold',
                }}
              >
                People at NicheSolv
              </p>
              <p>
                We are currently a very small team of young people apart from
                the aforementioned old guys.
              </p>
              <ul>
                <li>
                  We often wish the traffic noises were louder, so our ears are
                  saved from the same 4 songs on the guitar.
                  <br />
                </li>
                <li>
                  Serious arguments happen about who has to &apos;commute&apos;
                  to the water cooler to fill up the water bottles.
                </li>
                <li>People are giggling/laughing for apparently no reason.</li>
                <li>
                  Nobody will be stuck for too long at a problem, unless
                  it&apos;s just plain fun to watch. We have &apos;em all :
                  Studious, Organized, Front Benchers, Back benchers,
                  Disorganized, and everything in between.
                </li>
                <li>
                  All things you are very proud of - your talents, your dressing
                  style, how organized/disorganized you are - will be used
                  against you for a few laughs.
                </li>
                <li>
                  When a certain employee starts wearing a jacket inside the
                  office, we know he has run out of washed shirts.
                </li>
                <li>
                  A certain enlightened soul wears a single pair of jeans for 6
                  months - continously.Then he buys another one.
                </li>
                <li>
                  We hear statements like ".. R. D. Burman .... he was an actor,
                  right? "
                </li>
              </ul>
              <p />
            </div>
          </div>
          <br />
          <div className="row">
            <div className="col-md-12 col-lg-12">
              <p
                style={{
                  fontWeight: 'bold',
                }}
              >
                Work Environment
              </p>
              <p />
              <p>
                We have a nice little office that employees are very proud of
                decorating on our anniversary You&apos;ll have
              </p>
              <ul>
                <li>
                  Decent computers, monitors, tables and Featherlite chairs.
                </li>
                <li>Full power backup of course.</li>
                <li>Water, Air, Electricity.</li>
                <li>Good bandwidth.</li>
                <li>And the occasional free lunch &amp; beer.</li>
              </ul>
              <p />
            </div>
          </div>
          <br />
          <div className="row">
            <div className="col-md-12 col-lg-12">
              <p
                style={{
                  fontWeight: 'bold',
                }}
              >
                The way we choose
              </p>
              <p />
              <p />
              <ul>
                <li>
                  We value attitude more than aptitude. We also believe
                  no-experience is better than years of doing stuff without any
                  learning. Clear fundamentals of programming are more valuable
                  than spouting off names of frameworks/languages/buzzwords.
                </li>
                <li>
                  We expect you to be good problem solvers. So, the interview is
                  always a mix of puzzles &amp; programming questions. If you
                  don&apos;t have a programming background, it will be puzzle
                  heavy.
                </li>
                <li>
                  Freshers will go through a training/assessment period which
                  usually lasts between 2-4 months.
                </li>
              </ul>
              <p />
            </div>
          </div>
          <br />
          <div className="row">
            <div className="col-md-12 col-lg-12">
              <p
                style={{
                  fontWeight: 'bold',
                }}
              >
                Do we pay well?
              </p>
              <p />
              <p />
              <ul>
                <li>
                  We are generous as far as service company salaries go in
                  Bangalore. As far as service companies our size go, we are
                  very, very generous.
                </li>
              </ul>
              <p />
            </div>
          </div>
          {/*    <br />
                                <div className="row">
                                  <div className="col-md-12 col-lg-12">
                                    <p
                                      style={{
                  fontWeight: 'bold',
                }}
              >
                Are we hiring?
                                    </p>
                                      <p />
                                        <p />
                                          <ul>
                                            <li>
                  We do not hire often, but we are always interested in your
                  resumes. If you look interesting to us, we would also like to
                  talk to you. A job might not be in the offing immediately, but
                  it gives you and us a chance to talk and form an opinon about
                  each other.
                                            </li>
                Please send us your resume to <span>resumes@nichesolv.com</span>
                                          </ul>
                                            <p />
                                  </div>
                                </div> */}
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// /home/reetika/Desktop/nichesolvweb/website/nswebsite/src/containers/work.js